import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card-soundcloud',
  templateUrl: './card-soundcloud.component.html',
  styleUrls: ['./card-soundcloud.component.scss']
})
export class CardSoundcloudComponent implements OnInit {
  @Input() url: string;
  @Input() title: string;
  @Input() subtitle: string;

  constructor() { }

  ngOnInit() {
  }
}
